import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.module.scss';

const Spinner = ({ large, staticPos }) => (
  <div className={classnames(styles.spinner, { [styles.large]: large, [styles.staticPos]: staticPos })} />
);

Spinner.propTypes = {
  staticPos: PropTypes.bool,
  large: PropTypes.bool
};

Spinner.defaultProps = {
  staticPos: false,
  large: false
};

export default memo(Spinner);
